import errors from "./errors";
import categories from "./organizations/services-management/categories/categories";
import { Customer } from "./CRUDs/entities/Customer";
import { Section } from "./jobs-flow/Section";
import { Route } from "./Abstracts/Route";
import { TriggerFilter } from "./Common/Events/Events";

export default {
    customerRequest: (id = null) => {
        return new Customer(id);
    },
    init() {
        this.newCustomer();
        this.newCustomerMainPage();
        this.scroll();
        this.initCustomerOrders();
        this.organisationCustomerInfo();
        this.showCustomerMoreInfo();
        this.initPagination();
        this.queryParser();
        this.mobileMenu();
    },

    newCustomer() {
        $('#add-customer-modal').on('click', () => {
            this.customerRequest().openModal('create');
            let type = 'create';
            //customerUploadFiles.customerDocumentsMaidModal('upload-customer_files', type);
        })
    },
    newCustomerMainPage() {
        $('body').on('click', '#new_customer', function(e) {
            e.preventDefault();

            $.ajax({
                type: 'POST',
                url: '/new-customer',
                data: ({
                    name: $('#b_first_name').val(),
                    email: $('#b_email').val(),
                    phone: $('#b_phone').val(),
                    page_from: window.location.pathname,
                    lead_source: $('#lead_source').val(),
                }),
                success: function (response) {
                    $('.form-validation-errors').removeClass(['alert', 'alert-danger']);
                    $('.form-validation-errors').html('<div class="alert alert-success">'+ response.message +'</div>');
                    $('#register-form-modal').modal('show');
                    $('#register_form input#email').val($('#b_email').val());
                    $('#register_form input#phone').val($('#b_phone').val());
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            });
        });
    },
    scroll() {
        $('body').on('click', '.scroll_try', function(e) {
            e.preventDefault();
            window.scrollTo( 0, $(document).height() - $('#footer').height() - $('#try').height() );
        });
    },
    initCustomerOrders() {
        $('body').on('click', '#customer-orders-modal tr', function (e) {
            let elem = $(this);
            let form_type = elem.data('form-type');
            let order_id = elem.data('order_id');
            let job_id = elem.data('job_id');
            let entity_type = elem.data('entity');
            if(order_id) {
                $.ajax({
                    type: 'GET',
                    url: '/services-management/categories/get-complete-form',
                    data: {form_type, order_id},
                    success: (response) => {
                        $('#form-container').html(response);
                        categories.completeFormCategoryChange();
                        categories.serviceAttributeChangesValue();
                        categories.completeFormServiceChange();
                        categories.createOrderRequest();
                        //categories.serviceAttributeChangesValue();
                        $('#customer-orders-modal').modal('hide');
                        $('#service-request-modal').modal('show');
                    }
                });
            }
            if (job_id && entity_type) {
                $.ajax({
                    type: 'GET',
                    url: `/jobs-flow/customer-job`,
                    data: {form_type, job_id, entity_type},
                    success: (response) => {
                        $('#form-container').html(response);
                        //categories.serviceAttributeChangesValue();
                        $('#customer-orders-modal').modal('hide');
                        $('#view-job-modal').modal('show');
                    }
                });
            }
        });

    },
    organisationCustomerInfo(){
        let _this = this;
        $('body').on('click', '.customer-info-button', (e) => {
            e.preventDefault();
            let $button = $(this);

            if (!$button.prop('disabled')) {
                let customerId = $(e.target).data('customer-id');

                if (!customerId)
                    return false;

                let customerReq = _this.customerRequest(customerId);
                $.ajax({
                    type: 'GET',
                    //url: '/customers/get-info/' + customerId,
                    url: `/customers/form?entity=customer&type=contact&id=${customerId}&form-request=true`,
                    success: (response) => {
                        $('#form-container').html(response);
                        $('#contact-customer-modal').modal('show');
                        $('#customer-info-edit-customer').click((e) => {
                            e.preventDefault();
                            customerReq.openModal('edit', { id: customerId });
                            //openModal('customer', 'edit');
                            /* autocompleteForms('edit-customer', {
                                id: customerId,
                            }); */
                        });
                    }
                });

                $button.prop('disabled', true);
            }

            setTimeout(function() {
                $button.prop('disabled', false);
            }, 1500);
        });
    },
    showCustomerMoreInfo(){
        $('#customer_table').on('click', '.show_more_btn', function(e) {
            e.preventDefault();
            let customer_id = $(this).parent().data('customer_id');
            console.log($(this));

            $('.customer-info-'+customer_id).toggleClass('d-none');
            if ($('.customer-info-'+customer_id).hasClass('d-none')) {
                $(this).find('.arrow').css({'transform': '', 'top' : '12px'});
                $(this).find('span').text('More');
            } else {
                $(this).find('.arrow').css({'transform': 'rotate(225deg)', 'top' : '15px'});
                $(this).find('span').text('Close');
            }
        });
    },
    initPagination(){
        if (window.location.pathname == "/customers") {
            const section = new Section('customers');
            section.show();
        }
    },

    queryParser() {
        const filterContainer = $('.filter');
        const routes = [
            {
                location: '/customers',
                processedParams: {
                    'phone': (phone) => {
                        filterContainer.find('input').val(phone);
                        document.dispatchEvent(TriggerFilter);
                    },
                }
            }
        ]
        for (let routeOptions of routes) {
            Route.init(routeOptions);
        }
    },

    mobileMenu(){
        $('.customer-mobile-menu-btn').click(function() {
            console.log('click');

            if ($('.customer-management-modal').hasClass('opened')) {
                $('.customer-management-modal').removeClass('opened');
            } else {
                //$('.customer-management-modal').removeClass('opened');
                $('.customer-management-modal').addClass('opened');
            }
            let posX = $(this).position().left - ($('.customer-management-modal').width() + 10);
            let posY = $(this).position().top + ($('.customer-management-modal').height() + 30);
            $('.customer-management-modal').css({left: posX, top: posY});

        });
        $('body').off('click', '.customer-management-modal .close-elem')
        .on('click', '.customer-management-modal .close-elem', function() {
            $(this).parents('.customer-management-modal').removeClass('opened');
        });
    }
}
